import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// In production REACT_APP_API_URL is injected at build time (see .gitlab-ci.yml):
//   https://api.beehive-center.com/api/
// The fallback below is only used for local development.
const apiUrl = process.env.REACT_APP_API_URL || 'https://api.beehive-center.com/api/'

// Single fetcher that always attaches the latest access token (read per-request,
// so a refreshed token is picked up immediately).
const rawBaseQuery = fetchBaseQuery({
  baseUrl: apiUrl,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('token')
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const clearSessionAndRedirect = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('user')
  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}

// Avoid firing several refresh calls when multiple requests 401 at once.
let refreshPromise = null

export const baseQuery = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions)

  if (result.error && result.error.status === 401) {
    const refreshToken = localStorage.getItem('refresh_token')
    if (!refreshToken) {
      clearSessionAndRedirect()
      return result
    }

    // De-duplicate concurrent refreshes.
    if (!refreshPromise) {
      refreshPromise = rawBaseQuery(
        { url: 'auth/refresh', method: 'POST', body: { refresh_token: refreshToken } },
        api,
        extraOptions,
      ).finally(() => {
        refreshPromise = null
      })
    }

    const refreshResult = await refreshPromise

    if (refreshResult?.data?.access_token) {
      localStorage.setItem('token', refreshResult.data.access_token)
      if (refreshResult.data.refresh_token) {
        localStorage.setItem('refresh_token', refreshResult.data.refresh_token)
      }
      // Retry the original request with the new token.
      result = await rawBaseQuery(args, api, extraOptions)
    } else {
      clearSessionAndRedirect()
    }
  }

  return result
}
